import * as z from 'zod';
import * as ba from './base';
import { assertVueComponent } from '../helpers';
export class EmitAction extends ba.Action {
    static get manifest() {
        return {
            name: 'emit',
            schema: z.object({
                event: z.string(),
                value: z.any().optional(),
                source: z.string().optional()
            })
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        if (args.source === 'root') {
            return event.component.$root.$emit(args.event, args.value);
        }
        event.component.$emit(args.event, args.value);
    }
}
//# sourceMappingURL=emit.js.map